import React, { useEffect, useState } from 'react';
import {useSelector} from "react-redux";
import {getProfile} from "../../redux/reducers/user-profile-reducer.js";

import { RouteNames } from '../../router/consts.js';
import { useRedirect } from "../../hooks/useRedirect";
import {ContractProjectLayout} from "../../layouts/ContractProjectHeaderLayout/ContractProjectHeaderLayout";
import {ActList} from "../../containers/ActList/ActList";
import {ContractorAct} from "../../containers/ContractorAct/ContractorAct";
import { forwardingPath, getLoggedIn } from '../../redux/reducers/login-reducer.js';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min.js';
import { getInfoAct, getInfoViolation } from '../../redux/reducers/act-reducer.js';


export const HomePage = () => {
    const {user} = useSelector(getProfile)
    const ForwadingPath = useSelector(forwardingPath)
    const infoAct = useSelector(getInfoAct)
    const infoViolation = useSelector(getInfoViolation)
    const isLoggedIn = useSelector(getLoggedIn);

    const truePath = 
        infoViolation !== null 
            ? user?.is_staff 
                ? RouteNames.PODR_PAGE : RouteNames.HOME 

            : infoAct === null 
                ? isLoggedIn 
                    ? ForwadingPath : ForwadingPath 
                : ForwadingPath

    return <ContractProjectLayout>
        {user?.role === 'safety_engineer' || user?.role === 'project_manager' 
            ? <Redirect to={truePath === '/' ? RouteNames.LIBRARY: truePath} /> 
            : user?.role === 'contractor'? <ContractorAct/>:<ActList/>}
    </ContractProjectLayout>
}